.list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  width: 37.5rem;

  &.sm {
    gap: var(--space-sm);
  }
  &.md {
    gap: var(--space-md);
  }

  & > li {
    display: flex;
    align-items: start;
    gap: var(--space-sm);

    aside {
      display: flex;
      align-items: center;
      flex: 0 0 1.5rem;
      svg {
        width: 1.5rem;
        height: 1.5rem;
      }
    }

    a:visited {
      color: var(--interactive-default);
    }

    &:global(.empty) {
      svg {
        fill: var(--menu-empty);
      }
    }

    &:global(.warning) {
      svg {
        fill: var(--menu-warning);
      }
    }

    &:global(.accept) {
      svg {
        fill: var(--menu-accept);
      }
    }

    &:global(.error) {
      svg {
        fill: var(--color-error-darker);
      }
    }
  }
}

.title {
  font-weight: bold;
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}
